import ActionKeys from '../actions/ActionKeys';

const initialState = {
    detail: null,
}

export const promotionReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionKeys.CONFIG_PROMOTION.DETAIL:
            return {
                ...state,
                detail: action.data,
            };
        default:
            return state;
    }
};